import React, { useState } from 'react';
import { RingLoader } from 'react-spinners';
import './Shared.css';
function LoadingSpinner() {
  let [color, setColor] = useState("#36d7b7");
  return (
    <div className='overlay d-flex justify-content-center' >
      <div className='d-flex align-items-center'>
        <RingLoader
          color={color}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    </div>
  );
}

export default LoadingSpinner;